/**
 * @param {Object} $this
 * @param {Function} fn
 * @param {...*} [var1]
 * @returns {Function}
 */
D.closure = function ($this, fn, var1) {
	if (typeof fn !== 'function') {
		throw new Error('Closure fn not function');
	}
	let args = [];
	for (let i = 2; i < arguments.length; ++i) {
		args.push(arguments[i]);
	}
	return function () {
		$this = $this || this;
		let a = [];
		for (let i = 0; i < arguments.length; ++i) {
			a.push(arguments[i]);
		}
		return fn.apply($this, args.concat(a));
	};
};

/**
 * @param {Object} obj1
 * @param {*} obj2
 * @function
 */
function O2O(obj1, obj2) {
	if (typeof obj1 === 'undefined') {
		return;
	}
	if (typeof obj2 === 'undefined') {
		return;
	}
	for (let key in obj2) {
		let v = obj2[key];
		if (typeof v === 'undefined') {
			D.console.error(obj2, key);
		}
		if (v && v.constructor === Object) {
			if (!obj1[key]) {
				obj1[key] = {};
			}
			O2O(obj1[key], v);
		} else {
			try {
				obj1[key] = v;
			} catch (e) {
				D.console.error(e);
			}
		}
	}
}

function isset(v) {
	if (arguments.length > 1) {
		for (let i = 0; i < arguments.length; ++i) {
			if (!isset(arguments[i])) {
				return false;
			}
		}
		return true;
	}
	if (v === null) {
		return false;
	}
	return typeof v !== 'undefined';
}

function empty(v) {
	if (v === null) return true;
	switch (typeof v) {
		case 'object':
			if (typeof v.empty === 'function') {
				return v.empty();
			}
			for (let k in v) return false;
			break;
		case 'boolean':
		case 'number':
			return !v;
		case 'string':
			return (v === '' || v === '0');
		case  'function':
			return false;
	}
	return true;
}

function trim(str) {
	str = "" + str;
	if (String.prototype.trim) {
		return str.trim();
	}

	return str.replace(/^\s+|\s+$/g, '');
}

function reset(v) {
	for (let k in v) {
		return v[k];
	}
	return null;
}

function last( v ){
	if( v instanceof Array ){
		if( !v.length ){
			return null;
		}
		return v[ v.length - 1 ];
	}
	var last = null;
	for( var k in v ){
		last = v[k];
	}
	return last;
}

function count( v ){
	if( typeof v != 'object' ){
		return 1;
	}
	if( v instanceof Array ){
		return v.length;
	}
	if( typeof v.length == 'function' ){
		return v.length();
	}
	var l = 0;
	for( var k in v ) l ++;
	return l;
}

function is_array($v) {
	return $v instanceof Array;
}

function array_search(need, haystack, strict) {
	if (haystack instanceof Array && typeof haystack.indexOf === 'function' && !strict) {
		let i = haystack.indexOf(need);
		if (i !== -1) {
			return i;
		}
	} else if (typeof haystack === 'object' || typeof haystack === 'function') {
		for (let i in haystack) {
			if (array_search ? haystack[i] === need : haystack[i] === need) {
				return i;
			}
		}
	}
	return false;
}

/**
 * @param {*} needle
 * @param {Array.<*>} haystack
 * @returns {boolean}
 */
function in_array(needle, haystack) {
	let l = haystack.length;
	for (let i = 0; i < l; i++) {
		if (haystack[i] === needle) {
			return true;
		}
	}
	return false;
}

function getStyle(el, prop) {
	if (document.defaultView && document.defaultView.getComputedStyle) {
		return document.defaultView.getComputedStyle(el, null)[prop];
	} else if (el.currentStyle) {
		return el.currentStyle[prop];
	} else {
		return el.style[prop];
	}
}

function ucfirst(s) {
	return s.charAt(0).toUpperCase() + s.substr(1);
}

function str_pad ( input, pad_length, pad_string, pad_type ) {
	var half = '',
		pad_to_go;

	var str_pad_repeater = function (s, len) {
		var collect = '', i;

		while (collect.length < len) {
			collect += s;
		}
		collect = collect.substr(0, len);

		return collect;
	};

	input += '';
	pad_string = pad_string !== undefined ? pad_string : ' ';

	if (pad_type !== 'STR_PAD_LEFT' && pad_type !== 'STR_PAD_RIGHT' && pad_type !== 'STR_PAD_BOTH') {
		pad_type = 'STR_PAD_RIGHT';
	}

	if ((pad_to_go = pad_length - input.length) > 0) {
		if (pad_type === 'STR_PAD_LEFT') {
			input = str_pad_repeater(pad_string, pad_to_go) + input;
		} else if (pad_type === 'STR_PAD_RIGHT') {
			input = input + str_pad_repeater(pad_string, pad_to_go);
		} else if (pad_type === 'STR_PAD_BOTH') {
			half = str_pad_repeater(pad_string, Math.ceil(pad_to_go / 2));
			input = half + input + half;
			input = input.substr(0, pad_length);
		}
	}

	return input;
}

function getRandomInt(min, max) {
	return Math.floor(Math.random() * (max - min + 1) ) + min;
}

function nl2br(node) {
	D.replaceWithNode(node, /\n/g, function() {
		return mkE({
			tag: 'br'
		});
	});
}

function formatTextNode( node ) {
	D.replaceWithNode(node, /\n/g, () => {
		return mkE({
			tag: 'br'
		});
	});
	D.replaceWithNode(node, /<b>(.*)<\/b>/g, ( matches ) => {
		return mkE({
			tag: 'b',
			text: matches[1]
		});
	});
	D.replaceWithNode(node, /<p>(.*)<\/p>/g, ( matches ) => {
		return mkE({
			tag: 'p',
			text: matches[1]
		});
	});
	D.replaceWithNode(node, /\[([^\]]*)\](\(([^\)]*)\))?/g, ( matches ) => {
		if( !matches[1] || !matches[3] ) {
			return matches[0] || '';
		}
		if( matches[3].indexOf('#') === 0 ) {
			return mkE({
				tag: 'a',
				text: matches[1],
				onclick: function ( e ) {
					e.preventDefault();
					D.scrollIntoView(document.getElementById(this.hash.substr(1)));
				},
				href: matches[3]
			});
		} else {
			let link = D.url(matches[3]);
			if( matches[3].indexOf('mailto:') === 0 ) {
				link = matches[3];
			}
			if( matches[3].indexOf('https:') === 0 ) {
				link = matches[3];
			}
			return mkE({
				tag: 'a',
				text: matches[1],
				href: link
			});
		}
	});
	return node;
}

function nl2brText(text) {
	let node = mkE({tag: 'span', text: text});
	nl2br(node);
	return node.innerHTML;
}

D.svgIcon = function ( par ) {
	if( typeof par == 'string' ) {
		par = {icon: par};
	}
	let className = [
		'svg-icon',
		'svg-icon-' + par.icon
	];
	if( par.size ) {
		className.push('svg-icon-' + par.size);
	}
	if( par.className ) {
		className.push(par.className);
	}
	if( par.color && par.color[0] !== '#' ) {
		className.push('svg-icon-color-' + par.color);
		par.color = null;
	}
	let svg;
	try {
		svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
		svg.setAttribute('class', className.join(' '));
		if( par.fill ) {
			svg.setAttribute('fill', par.fill);
		}
		if( par.color ) {
			svg.setAttribute('color', par.color);
		}
		let useNode = document.createElementNS('http://www.w3.org/2000/svg', 'use');
		useNode.setAttributeNS('http://www.w3.org/1999/xlink', 'href', `/assets/images/symbol-defs.svg?v=${D.v}#icon-` + par.icon);
		svg.appendChild(useNode);
	} catch( e ) {
		svg = mkE({tag: 'span', className: className});
	}
	svg.append = mkE.append;
	return svg;
};